<ng-container>
  <ng-container *ngIf="profiles.length === 1; else profileList">
    <div class="">
      <a
        class="profile-with-logo"
        *ngIf="profiles[0] as loadedProfile"
        [routerLink]="profileLink(loadedProfile)"
        (click)="onCloseMenu()">
        <sh-profile-logo
          [hasLogo]="loadedProfile ? loadedProfile.hasLogo : false"
          [id]="loadedProfile ? loadedProfile.id : 0"
          [logoImageType]="loadedProfile?.logoImageType"
          [logoTheme]="loadedProfile.logoTheme ? loadedProfile.logoTheme : 1"
          [logoVersion]="loadedProfile ? loadedProfile.logoVersion : 1"
          [profileTitle]="loadedProfile.title ? loadedProfile.title : ''"></sh-profile-logo>
        <div>
          <a [attr.title]="loadedProfile?.title">
            {{ loadedProfile?.title }}
          </a>
        </div>
      </a>
    </div>
  </ng-container>

  <ng-template #profileList>
    <div class="profile-list">
      <a
        class="nav-item"
        *ngFor="let profileWhereUserIsAdmin of profiles | orderBy: 'title'"
        [routerLink]="profileLink(profileWhereUserIsAdmin)"
        (click)="onCloseMenu()"
        >{{ profileWhereUserIsAdmin.title }}</a
      >
    </div>
  </ng-template>
</ng-container>
